import React from 'react';

// Small floating readout shared by the daily charts; positioned by the chart.
const ChartTooltip = ({ x, y, title, rows }) => (
  <div className="qa-chart-tip" style={{ left: x, top: y }}>
    <div className="qa-chart-tip__title">{title}</div>
    {rows.map((r) => (
      <div key={r.label} className="qa-chart-tip__row">
        {r.color && <span className="qa-chart-tip__swatch" style={{ background: r.color }} />}
        <span className="qa-chart-tip__label">{r.label}</span>
        <span className="qa-chart-tip__value">{r.value}</span>
      </div>
    ))}
  </div>
);

export default ChartTooltip;
